<template>
  <!-- 我的禮物盒頁 -->
  <div class="gift-box__container">
    <MemberContentTitle :title="$t('my_gift_box')" />
    <MemberTabs v-model="giftTab" :tabs="tabs" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import MemberContentTitle from '@/components/member/MemberContentTitle.vue'
import MemberTabs from '@/components/member/MemberTabs.vue'
import GiftList from '@/components/gift/GiftList.vue'

import tools from '@/mixin/tools'
import { useMemberPageAuth } from '@/composition/useMemberPageAuth'

const ReceiveGiftCard = defineAsyncComponent(() => import('@/components/card/receive-gift-card.vue'))
const SendGiftCard = defineAsyncComponent(() => import('@/components/card/send-gift-card.vue'))

export default defineNuxtComponent({
  name: 'GiftListPage',
  components: {
    MemberContentTitle,
    MemberTabs,
  },
  mixins: [tools],
  setup() {
    useMemberPageAuth()

    return {}
  },
  data() {
    return {
      giftTab: null,
      isIntersecting: false,
      isReceiveGiftsEnd: false,
      isSendGiftsEnd: false,
      startReceiveGiftsIndex: 0,
      startSendGiftsIndex: 0,
      defaultSize: 12,
    }
  },
  head() {
    return {
      meta: [{ name: 'robots', content: 'noindex' }],
    }
  },
  computed: {
    loggedInUser() {
      return this.$auth.user
    },
    ...mapGetters({
      receiveGifts: 'gift/receiveGifts',
      sendGifts: 'gift/sendGifts',
    }),
    tabs() {
      return [
        {
          label: this.$t('receive_gift'),
          value: 'received',
          contentComponent: GiftList,
          contentComponentProps: {
            gifts: this.receiveGifts,
            isEnd: this.isReceiveGiftsEnd,
            emptyText: this.$t('receive_gift_empty'),
            cardComponent: ReceiveGiftCard,
            onIntersect: this.onIntersect,
          },
        },
        {
          label: this.$t('send_gift'),
          value: 'created',
          contentComponent: GiftList,
          contentComponentProps: {
            gifts: this.sendGifts,
            isEnd: this.isSendGiftsEnd,
            emptyText: this.$t('send_gift_empty'),
            cardComponent: SendGiftCard,
            onIntersect: this.onIntersect,
          },
        },
      ]
    },
  },
  watch: {
    loggedInUser(userInfo) {
      if (userInfo) {
        this.getUserGifts()
      } else {
        this.$store.dispatch('gift/resetGifts')
      }
    },
    giftTab(newTab) {
      this.changeTab(newTab)
    },
  },
  asyncData(nuxtApp) {
    const { query } = getNuxtContext(nuxtApp)
    const hasTab = query.tab === 'received' || query.tab === 'created'
    return {
      giftTab: hasTab ? query.tab : 'received',
    }
  },
  beforeUnmount() {
    this.$store.dispatch('gift/resetGifts')
  },
  methods: {
    onIntersect(isIntersecting, entries, observer) {
      this.isIntersecting = entries[0].intersectionRatio >= 0.5
      const isEnd = this.giftTab === 'received' ? this.isReceiveGiftsEnd : this.isSendGiftsEnd

      if (this.isIntersecting && !isEnd) {
        this.getUserGifts()
      }
    },
    setGiftsEnd(status) {
      if (this.giftTab === 'received') {
        this.isReceiveGiftsEnd = status
      } else {
        this.isSendGiftsEnd = status
      }
    },
    getDataStart() {
      const index = this.giftTab === 'received' ? this.startReceiveGiftsIndex : this.startSendGiftsIndex
      return this.defaultSize * index
    },
    getUserGifts() {
      const queryObj = {
        size: this.defaultSize,
        type: this.giftTab,
      }

      Object.assign(queryObj, {
        start: this.getDataStart(),
      })

      this.$store.dispatch('gift/getGiftItems', queryObj).then(res => {
        if (this.giftTab === 'received') {
          this.startReceiveGiftsIndex += 1
        } else {
          this.startSendGiftsIndex += 1
        }

        if (res.code === 0 && res.data.length === 0) {
          this.setGiftsEnd(true)
        } else if (res.code === 0) {
          setTimeout(() => {
            if (this.isIntersecting) {
              this.getUserGifts()
            }
          }, 500)
        }
      })
    },
    changeTab(value) {
      this.$router.push({ query: { tab: value } })
    },
  },
})
</script>
